// components/CBEDepositModal.jsx
import React, { useState } from "react";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const CBEDepositModal = ({ onClose }) => {
  const [receiptNumber, setReceiptNumber] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleCheck = async () => {
    if (!receiptNumber.trim()) {
      toast.error("Please enter your CBE receipt number!");
      return;
    }

    setIsLoading(true);

    try {
      // 🔹 Simulated backend call (replace with your actual API)
      const response = await new Promise((resolve) =>
        setTimeout(() => resolve({ success: true }), 2000),
      );
      // const response = await axiosInstance.post("/api/verify-telebirr", {
      //   receiptNumber,
      // });
      if (response.success) {
        toast.success("Transaction verified successfully!");
      } else {
        toast.error("Transaction not found or invalid.");
      }

      //       if (response.data.success) {
      //   toast.success(response.data.message || "Transaction verified successfully!");
      // } else {
      //   toast.error(response.data.message || "Transaction not found or invalid!");
      // }
    } catch (error) {
      toast.error("Error verifying transaction. Try again!");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-[9999]">
      <div className="bg-[#0d2d61] text-white rounded-lg shadow-2xl w-[420px] border border-blue-900 relative animate-fadeIn">
        {/* Close button */}
        <button
          onClick={onClose}
          className="absolute top-2 right-3 text-white text-2xl hover:text-gray-300"
        >
          ✕
        </button>

        {/* Header */}
        <div className="bg-[#10316b] px-4 py-3 rounded-t-lg border-b border-[#1a4a8e] text-center">
          <h2 className="text-lg font-semibold font-serif">
            CBE Transfer Deposit
          </h2>
        </div>

        {/* Body */}
        <div className="px-5 py-4 text-[15px] leading-relaxed">
          <p className="text-yellow-400 font-medium mb-2 font-serif">
            ማስገባት የፈለጉትን መጠን ከእርሶ ሲቢኢ ብር ወደዚ ስልክ ቁጥር ሲቢኢ ብር ትራንስፈር ሲያረጉ ወደ 40ምንጭ
            ቢንጎ አካውቶ ገቢ ይደረግሎታል
          </p>

          <ol className="list-decimal list-inside text-white space-y-1 mt-2 font-serif">
            <li>CBE-Birr App ወይም *847# ገብተው</li>
            <li>በዚ ቁጥር ብቻ ትራንስፈር ያርጉ</li>
            <li>ወዲያውኑ ዘመድ ቢንጎ አካውቶ ላይ ይገባሎታል</li>
          </ol>

          {/* Info Box */}
          <div className="bg-white text-[#0d2d61] rounded-md px-4 py-3 mt-4">
            <div className="flex justify-between">
              <span className="font-semibold">ስልክ ቁጥር፡</span>
              <span className="font-bold">0964060000</span>
            </div>
            <div className="flex justify-between mt-1">
              <span className="font-semibold">ስም፡</span>
              <span>መልካሙ</span>
            </div>
          </div>

          <p className="text-red-500 text-sm mt-3 text-center font-medium font-serif">
            ትራንስፈር የምታረጉበት ቁጥር 40ምንጭ ቢንጎ አካውቶ ጋር 1 አይነት መሆን አለበት ገቢ የሚደረገሎት እሱ
            ላይ ብቻ ነው
          </p>

          {/* Transaction Input */}
          {/* <div className="bg-[#134454] mt-4 p-3 rounded-md border border-[#1a4a8e] font-serif">
            <h3 className="text-white font-semibold text-sm mb-2">
              ከሲቢኢ ብር ያልገባ ገንዘብ አሎት?
            </h3>
            <label className="block text-sm mb-1">Transaction ቁጥር ያስገቡ</label>
            <input
              type="text"
              value={receiptNumber}
              onChange={(e) => setReceiptNumber(e.target.value)}
              placeholder="Cbebirr መልእክት ወይም Receipt ላይ ያገኙታል"
              className="w-full px-3 py-2 rounded-md text-gray-900 text-sm focus:outline-none"
            />

        
            <button
              onClick={handleCheck}
              disabled={isLoading}
              className={`w-full mt-4 bg-gradient-to-r from-red-500 to-cyan-600 hover:from-blue-700 hover:to-indigo-800 text-white py-2 rounded-md transition font-semibold flex items-center justify-center ${
                isLoading ? "opacity-70 cursor-not-allowed" : ""
              }`}
            >
              {isLoading ? (
                <div className="flex items-center space-x-2">
                  <span className="animate-spin border-2 border-t-transparent border-white rounded-full w-4 h-4"></span>
                  <span>Checking...</span>
                </div>
              ) : (
                "ቼክ ያድርጉ"
              )}
            </button>
          </div> */}
        </div>
      </div>

      {/* Toast Container */}
      <ToastContainer position="top-right" autoClose={3000} theme="colored" />
    </div>
  );
};

export default CBEDepositModal;
